"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getInputName = (forFieldProps) => forFieldProps.parentObjectName ? forFieldProps.parentObjectName + '.' + forFieldProps.name : forFieldProps.name;
exports.default = getInputName;
